module.exports = __webpack_public_path__ + "img/grid.d8b09375.svg";